import { hideAndRemove } from "../../helpers";
import { toggleSceneObject } from "../../togglers";

export const changeTableTumbaSP = (value, isChecked, side) => {
    if (typeof value !== "string") return console.warn("[changeTableTumbaSP] Не корректный value", value);
    if (typeof isChecked !== "boolean") return console.warn("[changeTableTumbaSP] Не корректный isChecked", isChecked);
    if (typeof side !== "string") return console.warn("[changeTableTumbaSP] Не корректный side", side);

    const tempName = servObj.tempName;
    const tableWidth = servObj.tableSize.tableWidth.current;
    const tableDepth = servObj.tableSize.tableDepth.current;
    const namePSKP = `tumba__${value}__stol__${tempName}`;
    const nameOther = `tumba__${value}__stol__${tempName}__${tableWidth}x${tableDepth}__${side}`;
    const isPSKP = servObj.tempName === "ps_kp";
    const name = isPSKP ? namePSKP : nameOther;

    const table_width = servObj.tableSize.tableWidth.current;

    const visibleChildren = [`__key_${side}`];

    const MAX_X_VALUES = {
        1200: { min: -0.295, max: 0.275 },
        1000: { min: -0.195, max: 0.175 },
    };
    toggleSceneObject({
        allObjects: servObj.allTumbaSP,
        activeArray: servObj.activeTumbaSP,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: 10,
        },
        userData: {
            type: value,
            position: "bottom",
            horizontalOnly: isPSKP,
            max_x_value: MAX_X_VALUES[table_width],
            side,
            visibleChildren,
        },
        hideChildrenName: ["__key"],
    });
};
